module.exports = __webpack_public_path__ + "static/media/my_pic.5b056ed6.jpg";